var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CutInternet",class:{'active': _vm.active}},[_c('div',{staticClass:"CutInternet-box"},[_c('video',{staticClass:"video",attrs:{"controls":false,"autoplay":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.openVideo,"type":"video/mp4"}}),_vm._v(" 您的浏览器不支持 video 标签。 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }